window.REBASE = window.REBASE || {};
REBASE.theme = {};
window.photo_gallery = {};

(function ($) {
  const shippingInput = $("#shipping_selection_shipped");
  const pickUpInput = $("#shipping_selection_pickup");
  const sameDayDeliveryInput = $("#shipping_selection_sameday_delivery");
  const addToCartButton = $("#add-to-cart");
  const addToCartText = $("#add-to-cart-text");
  const pdpLocationSelection = $(".product-page-location-selection");
  const pickupSelection = $(
    ".purchase-option--pickup .product-page-location-selection"
  );
  const sameDayDeliverySelection = $(
    ".purchase-option--sameday-delivery .product-page-location-selection"
  );
  const locationSelection = $(".location-selection");

  const locationSyncData = document.querySelector("[data-location-sync]")
    ?.innerHTML
    ? JSON.parse(document.querySelector("[data-location-sync]").innerHTML)
    : null;
  const GADGET_URL =
    locationSyncData?.location_sync_gadget_app_url ||
    "https://ps-inventory-sync.gadget.app";

  window.GADGET_URL = GADGET_URL;

  /**
   * Order Groove Selectors
   */
  const ogOffer = $("og-offer");

  /**
   * Returns the active purchase option preference
   * Possible Values: shipped | pickup | sameday_delivery
   */
  const getPurchaseOption = () => {
    const activeInput = document.querySelector(".purchase-option.active input");
    const value = activeInput ? activeInput.value : null;
    const storageKey =
      value === "pickup" ? "locationSelection" : "deliverySelection";

    return { purchaseOption: value, storageKey, activeInput };
  };

  const disableInputs = () => {
    /**
     * If pickup input is disabled, set disabled state
     */
    if (pickUpInput.prop("disabled")) {
      pickUpInput.parent().closest(".purchase-option").addClass("disabled");
    }

    /**
     * If pickup input is disabled, set disabled state
     */
    if (sameDayDeliveryInput.prop("disabled")) {
      sameDayDeliveryInput
        .parent()
        .closest(".purchase-option")
        .addClass("disabled");
    }

    if (shippingInput.prop("disabled")) {
      shippingInput.parent().closest(".purchase-option").addClass("disabled");
    }
  };

  const optOutOfSubscription = () => {
    const optOut = document.querySelector("og-optout-button");
    if (optOut) {
      optOut.click();
    }
  };

  const onReadyDomElement = (element, callback) => {
    if (jQuery(element).length) {
      callback(jQuery(element));
    } else {
      setTimeout(function () {
        onReadyDomElement(element, callback);
      }, 100);
    }
  };

  const displayPortalLink = (id) => {
    const orderGrooveDetails = $(".order-groove-details");
    const variantId = id || $("#product-select").val();

    setTimeout(() => {
      const ogState = og.store.getState();
      const autoshipEligible = ogState.autoshipEligible[variantId];

      if (!orderGrooveDetails) {
        return;
      }

      if (autoshipEligible) {
        orderGrooveDetails.show();
      } else {
        orderGrooveDetails.hide();
      }
    }, 1000);
  };

  // Check for when og-offer is rendered
  onReadyDomElement("og-offer", function (e) {
    const config = { attributes: true, attributeOldValue: true };

    // If upsell modal is closed, force opt out of subscription
    const callback = (mutationList) => {
      const modal = mutationList[0].target;
      if (!modal.hasAttribute("show")) {
        const optOut = mutationList[0].target.querySelector("og-optout-button");
        optOut.click();
      }
    };

    const ogModal = document.querySelector("og-upsell-modal");
    const observer = new MutationObserver(callback);
    if (ogModal && observer) {
      observer.observe(ogModal, config);
      displayPortalLink();
    }
  });

  const getShipPref = () => {
    return localStorage.getItem("shipPref");
  };

  $(function () {
    var BODY = $("body"),
      IS_PRODUCT = BODY.hasClass("product-template"),
      SIDEBAR_TOGGLE = $("#collection-filtering-toggle"),
      COLLECTION_SIDEBAR = $(".filtering-container");

    if (IS_PRODUCT) {
      REBASE.theme.bindProductControls();
    }

    /* ----------------------------------------------------------------
    Collection Page
    -----------------------------------------------------------------*/

    //Collection sidebar
    SIDEBAR_TOGGLE.on("click", function () {
      if (SIDEBAR_TOGGLE.hasClass("toggled")) {
        $("span", this).text("Filter");
        $(this).removeClass("toggled");
      } else {
        $(this).addClass("toggled");
        $("span", this).text("Close");
      }
      // $('.filtering-group h3').trigger('click');
      COLLECTION_SIDEBAR.toggleClass("shown");
    });

    $(".filtering-list-max-height-toggle").on("click", function () {
      $(this).prev().toggleClass("filtering-list--max-height");
      $(this).find("span").toggleClass("hidden");
      return false;
    });

    //Collection template filtering
    $(".filtering-group h3").on("click", function () {
      $(this).find("svg").toggleClass("hidden");
      $(this).parent().toggleClass("collapsed");
    });

    /* ----------------------------------------------------------------
    Quickview Modal
    -----------------------------------------------------------------*/
    // variables
    var modalWrapper = $(".modal-wrapper--quickview"),
      modal = $(".modal-wrapper--quickview .modal"),
      modalClose = $(".modal-wrapper--quickview .modal__close"),
      modalContent = $(".modal-wrapper--quickview .modal__content"),
      modalContentWrapper = $(
        ".modal-wrapper--quickview .modal__content-wrapper"
      );

    // loads product via ajax and runs transitions
    function loadProduct() {
      var product = $(this),
        productData = $(product).data("qv") + "?view=quickview";
      $.get(productData, function (data) {
        // open modal
        $("body").addClass("modal-shown");
        $(modalWrapper).addClass("shown");
        $(modal).addClass("animate");
        $(modalContent).html(data);
        $("#modal__view-details").attr("href", $(product).data("qv"));
        REBASE.theme.unbindProductControls();
        REBASE.theme.bindProductControls();
        // REBASE.theme.customBindListsEvents($);

        setTimeout(function () {
          $(product).closest(".product");
          $(product).text("Quick Shop");
          $(modalContentWrapper).addClass("animate");
        }, 300);
      });
    }

    // closes modal
    function closeModal(e) {
      e.preventDefault();
      $("body").removeClass("modal-shown");
      $(modal).removeClass("animate");
      $(modalWrapper).removeClass("shown");
      $(modalContentWrapper).removeClass("animate");
    }

    // when quickview is clicked we run loadProduct
    $(".product__quickview").on("click", function (e) {
      e.preventDefault();
      $(this).text("Loading...").closest(".product");
      loadProduct.call($(this));
    });

    $(modalClose).on("click", closeModal);

    //Feeding Notice Disclaimer Modal

    const feedingNoticeModalOverlay = $(
      "#feeding-guide-disclaimer-modal--overlay"
    );
    const feedingNoticeModalBtn = $("#feeding-guide-disclaimer--btn");
    const feedingNoticeModalContainer = $(
      ".feeding-guide-disclaimer-modal--container"
    );
    const feedingNoticeModalBtnClose = $(
      "#feeding-guide-disclaimer-btn--close"
    );
    function showFeedingNotice() {
      feedingNoticeModalBtn.on("click", function () {
        feedingNoticeModalOverlay.show();
        feedingNoticeModalContainer.show();
      });
    }

    function hideFeedingNotice() {
      feedingNoticeModalBtnClose.on("click", function () {
        feedingNoticeModalOverlay.hide();
        feedingNoticeModalContainer.hide();
      });
    }

    showFeedingNotice();
    hideFeedingNotice();

    $(window).on("click", function (event) {
      let target = $(event.target);
      if (target.is(feedingNoticeModalContainer)) {
        feedingNoticeModalOverlay.hide();
        feedingNoticeModalContainer.hide();
      }
    });
  });

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Setup Product page controls (needs to run on product pages and when quickview is opened)
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.unbindProductControls = function () {
    $(
      ".add-item-section__toggle--add-on, #product-qty-input, #product-rating, #product-description"
    ).off(".rbProduct");
  };

  REBASE.theme.bindProductControls = function () {
    var product;

    $(".add-item-section__toggle--add-on").on("click.rbProduct", function (e) {
      e.preventDefault();
      $(this).find("svg").toggleClass("hidden");
      $(this)
        .toggleClass("add-item-section__toggle--active")
        .parent()
        .toggleClass("add-on-product--selected");

      if (typeof calculateAddOnPrice === "function") {
        calculateAddOnPrice();
      }
    });

    // Quantity buttons
    $(".qtyplus, .qtyminus").show();
    $("#product-qty-input").on(
      "click.rbProduct",
      ".qtyplus, .qtyminus",
      function (e) {
        var quantity_input = $("#quantity"),
          quant_val = parseInt(quantity_input.val());

        e.preventDefault();
        if ($(e.target).hasClass("qtyplus")) {
          if (!quant_val) {
            quant_val = 0;
          }
          quant_val += 1;
        } else {
          if (!quant_val) {
            quant_val = 1;
          }
          if (quant_val > 1) {
            quant_val -= 1;
          }
        }

        quantity_input.val(quant_val);
      }
    );

    // Product Reviews
    $("#product-rating").on("click.rbProduct", function (e) {
      $(".product-content-section-title--reviews h3").trigger("click");
    });

    window.initLocationUI();

    const setInitialActivePurchaseOption = () => {
      const locationSelection = JSON.parse(
        localStorage.getItem("locationSelection")
      );
      const deliverySelection = JSON.parse(
        localStorage.getItem("deliverySelection")
      );

      const purchaseOptions = document.querySelectorAll(
        ".purchase-option.active"
      );

      if (!purchaseOptions?.length) {
        const radioInputs = document.querySelectorAll(
          '.purchase-option input[type="radio"]:not([disabled])'
        );

        if (radioInputs.length > 0) {
          const firstRadioInput = radioInputs[0];
          const purchaseOptionElement = firstRadioInput.parentNode.parentNode;
          const productPageSelection = purchaseOptionElement.querySelector(
            ".product-page-location-selection"
          );
          firstRadioInput.checked = true;

          if (purchaseOptionElement) {
            purchaseOptionElement.classList.add("active");
          }

          if (productPageSelection) {
            productPageSelection.classList.add("expand");
          }

          if (!locationSelection || !deliverySelection) {
            addToCartButton.attr("disabled", true);
            localStorage.setItem("shipPref", firstRadioInput.id);
            lookupInventory();
          }
        }
      }
    };

    const setActivePurchaseOption = () => {
      const shipPref = getShipPref();

      /**
       * If shipPref is not set, set active & expand class on the first available purchase option
       * Make the first available option the shipPref
       */
      if (!shipPref) {
        setInitialActivePurchaseOption();
        return;
      }

      // If shipPref is set, set active & expand class on purchase option
      if ($(`#${shipPref}`).prop("disabled") !== true) {
        $(".product-page-location-selection").addClass("expand");
        $(`#${shipPref}`).prop("checked", true);
        $(`#${shipPref}`).parent().parent().addClass("active");
      }
    };

    /**
     * Initial load, if shippingInput is disabled, disable ship to me
     */
    if (shippingInput.is(":disabled")) {
      disableInputs();
    }

    /**
     * Make inventory call to check availability of product variant
     */
    const checkLocationInventory = async (selectedVariant) => {
      const { purchaseOption, storageKey } = getPurchaseOption();
      if (!purchaseOption) {
        return;
      }
      const locationData = localStorage.getItem(storageKey);
      let locationGID;

      /** Remove "Physical Location -" from the name of the store, to get the location ID in the shopify store name e.g 7001 */
      if (locationData) {
        locationGID = JSON.parse(locationData).id;
      }
      fetch(
        `${window.GADGET_URL}/inventory/stock?productVariants=${selectedVariant.id}&locationId=${locationGID}`
      )
        .then((res) => res.json())
        .then((data) => {
          /** If quantity is greater than 0, display badge and enable ATC button */
          const quantity = data[0]?.available;
          if (quantity > 0) {
            /** Set availability badge */
            if (purchaseOption === "pickup") {
              $(".pickup-availability-message")
                .removeClass("pickup--error")
                .html(`${quantity} available`);

              /** If pickup is checked, enable add to cart, else disable */
              if ($("#shipping_selection_pickup:checked").length) {
                addToCartButton.attr("disabled", false).show();
                addToCartText.text("Add To Cart");
              } else {
                addToCartButton.attr("disabled", false);
              }
            }

            if (purchaseOption === "sameday_delivery") {
              $(".sameday-delivery-availability-message")
                .removeClass("sameday-delivery--error")
                .html(`${quantity} available`);

              if ($("#shipping_selection_sameday_delivery:checked").length) {
                addToCartButton.attr("disabled", false).show();
                addToCartText.text("Add To Cart");
              } else {
                addToCartButton.attr("disabled", false);
              }
            }
          } else {
            /** If no inventory stock exists within shopify, show not available badge */
            if (purchaseOption === "pickup") {
              $(".pickup-availability-message")
                .addClass("pickup--error")
                .html("Not Available");
            }
            if (purchaseOption === "sameday_delivery") {
              $(".sameday-delivery-availability-message")
                .addClass("sameday-delivery--error")
                .html("Not Available");
            }
            /** Set add to cart button to be disabled */
            addToCartButton.attr("disabled", true);
          }
        });
    };

    const lookupInventory = (variant) => {
      // Wrapped in a settime out to move this function to the end of the call stack
      setTimeout(() => {
        const { storageKey } = getPurchaseOption();
        let locationData = JSON.parse(localStorage.getItem(storageKey)),
          productJSON = JSON.parse($("#product__json").html()),
          selectedVariantID =
            (variant && variant.id) || $("#product-select").val(),
          selectedVariant;

        // if we don't have a location set, bail
        if (!locationData) {
          return;
        }

        // get the selected variant
        selectedVariant = productJSON.variants.filter(function (variant) {
          return variant.id == parseInt(selectedVariantID);
        })[0];

        /** Set master product hidden select */
        const masterProductSelect = document.querySelector("#product-select");
        masterProductSelect.value = selectedVariant.id;

        const { activeInput } = getPurchaseOption();
        const purchaseOptionElement = activeInput.parentNode.parentNode;
        const purchaseOptionBadge = purchaseOptionElement.querySelector(
          ".purchase-option-badge"
        );

        purchaseOptionElement.classList.add("active");
        purchaseOptionElement
          .querySelector(".product-page-location-selection")
          .classList.add("expand");

        purchaseOptionBadge.classList.add("badge");
        purchaseOptionBadge.innerHTML = "Loading...";
        disableInputs();

        /**
         * If shipping input is already disabled or if selectedVariant is not enabled disable inputs
         */
        if (shippingInput.is(":disabled") || !selectedVariant.available) {
          disableInputs();
        } else {
          /**
           * Enable Shipping Input
           */
          shippingInput
            .parent()
            .closest(".purchase-option")
            .removeClass("disabled");
        }

        /**
         * Set ATC button to disabled to prevent any edge cases
         */
        addToCartButton.attr("disabled", true);

        /**
         * Grab inventory stock for the selectedVariant
         */
        checkLocationInventory(selectedVariant);
      }, 0);
    };

    /**
     *
     * @param {*} variant
     * @returns Get SFS inventory for specific sku
     */
    const lookUpSFSInventory = async (variant) => {
      const shippingBadge = document.querySelector(
        ".shipping-availability-message"
      );
      shippingBadge?.classList?.add("badge");
      shippingBadge.innerHTML = "Loading...";
      addToCartButton.attr("disabled", true);
      let variantId = variant?.id || "";

      /** If gadget URL does not exist, do nothing */
      if (!window.GADGET_URL) {
        return;
      }

      /** If is not passed, get the master select value and get the sku */
      if (!variant) {
        variantId = document.querySelector("#product-select").value;
      }

      try {
        const sfsInventory = await fetch(
          `${GADGET_URL}/sfs/stock?productVariants=${variantId}`
        )
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => data);

        const quantity = sfsInventory[0]?.available;
        if (quantity > 0) {
          addToCartButton.attr("disabled", false);
          shippingBadge.innerHTML = `${quantity} available`;
        } else {
          shippingBadge.innerHTML = "Not Available";
        }
      } catch (error) {
        return { error: true, message: error.message };
      }
    };

    /** Set this function to the window, so it can be used in the rebase theme without prop drilling */
    window.lookUpSFSInventory = lookUpSFSInventory;

    const shipPref = getShipPref();

    const purchaseOptionNotMatched = () => {
      const radioInputs = document.querySelectorAll(
        '.purchase-option input[type="radio"]:not([disabled])'
      );

      if (!radioInputs?.length) return;

      const firstRadio = radioInputs[0];
      const purchaseOptionEl = firstRadio.closest(".purchase-option");

      // Select the first available radio input
      firstRadio.checked = true;
      localStorage.setItem("shipPref", firstRadio.id);
      purchaseOptionEl?.classList.add("active");

      // Handle based on selected shipping preference
      const isShipped = firstRadio.id === "shipping_selection_shipped";

      if (isShipped) {
        lookUpSFSInventory();
      } else {
        purchaseOptionEl
          ?.querySelector(".product-page-location-selection")
          ?.classList.add("expand");
        lookupInventory();
      }
    };

    if (shipPref) {
      $("#add-to-cart").attr("disabled", false);
      disableInputs();

      /**
       * There are three cases where we look up the inventory:
       * Case 1: current shipPref is set to pick up and the pickup input is not disabled
       * Case 2: current shipPref is set to same day delivery and the pickup input is not disabled
       * Case 3: shippingInput is disabled (shipPref is voided)and pickUpInput is not disabled
       * Lookup Inventory + set status of shipping_selection_pickup to checked, show location selection and lookup inventory
       */

      /**
       * If shipPref is set to "shipping_selection_pickup" and pickup input is not disabled
       * Check if locationSelection to see if data exists in local storage, if it does set active class on pickup input and do inventory call
       */
      if (
        shipPref === "shipping_selection_pickup" &&
        !pickUpInput.prop("disabled")
      ) {
        if (getShipPref() != "shipping_selection_pickup") {
          localStorage.setItem("shipPref", "shipping_selection_pickup");
        }

        addToCartButton.attr("disabled", true);
        pickUpInput.prop("checked", true);
        const locationSelectionProduct = $(".location-selection .product");
        locationSelectionProduct.show();
        optOutOfSubscription();
        const purchaseOptionPickup = document.querySelector(
          ".purchase-option--pickup"
        );
        if (purchaseOptionPickup) {
          purchaseOptionPickup.classList.add("active");
          purchaseOptionPickup
            .querySelector(".product-page-location-selection")
            .classList.add("expand");
        }

        const bopisLocationData = JSON.parse(
          localStorage.getItem("locationSelection")
        );
        if (bopisLocationData) {
          lookupInventory();
        }
      } else if (
        getShipPref() === "shipping_selection_sameday_delivery" &&
        !sameDayDeliveryInput.prop("disabled")
      ) {
        /**
         * If shipPref is set to "shipping_selection_sameday_delivery" and sameday delivery input is not disabled
         * Check if deliverySelection to see if data exists in local storage, if it does set active class on sameday delivery input and do inventory call
         */
        if (getShipPref() != "shipping_selection_sameday_delivery") {
          localStorage.setItem(
            "shipPref",
            "shipping_selection_sameday_delivery"
          );
        }
        addToCartButton.attr("disabled", true);
        sameDayDeliveryInput.prop("checked", true);
        const locationSelectionSameDay = $(".location-selection .sameday");
        locationSelectionSameDay.show();
        lookupInventory();
        optOutOfSubscription();
        const purchaseOptionSameDay = document.querySelector(
          ".purchase-option--sameday-delivery"
        );
        purchaseOptionSameDay.classList.add("active");
        purchaseOptionSameDay
          .querySelector(".product-page-location-selection")
          .classList.add("expand");

        const sameDayDeliveryLocationData = JSON.parse(
          localStorage.getItem("deliverySelection")
        );
        if (sameDayDeliveryLocationData) {
          lookupInventory();
        }
      } else if (
        getShipPref() === "shipping_selection_shipped" &&
        !shippingInput.prop("disabled")
      ) {
        /**
         * Set active class on shipping input if it exists in locationData and is not disabled
         */
        shippingInput.parent().closest(".purchase-option").addClass("active");
        $(".shipping-availability-message").addClass("badge");
        $(".shipping-availability-message").innerHTML = "Loading...";

        /** Look up SFS inventory if the ship pref is currently shipping */
        lookUpSFSInventory();
      } else {
        /**
         * Catch all fail safe, if the shipPref doesnt match the current selected option
         * Find the first available option and do the inventory call checks
         */
        purchaseOptionNotMatched(shipPref);
      }
    } else {
      // if a store isn't set, check if Ship To Me is available
      const isDisabled =
        $("#shipping_selection_shipped").attr("disabled") == "disabled";
      addToCartButton.attr("disabled", isDisabled);
      disableInputs();
      setActivePurchaseOption();
    }

    /**
     * If location data exists, on variant change lookupInventory for current selected variant
     */
    $("#add-item-form").on("variantChange", function (e) {
      if (
        [
          "shipping_selection_pickup",
          "shipping_selection_sameday_delivery",
        ].includes(getShipPref()) &&
        !pickUpInput.prop("disabled")
      ) {
        lookupInventory(e.variant);
      }
    });

    /**
     * Store location change, look up inventory for that specific store for current selected variant
     */
    $(document).on("setStore.rbLocation", function (e) {
      addToCartButton.attr("disabled", false);
      lookupInventory();
    });

    /**
     * If Shipped or Pickup is selected, hide location selection
     */
    $("#shipping_selection_shipped").on("change", function (e) {
      pdpLocationSelection.removeClass("expand");
      locationSelection.hide();
    });
    $("#shipping_selection_pickup").on("change", function (e) {
      pdpLocationSelection.removeClass("expand");
      locationSelection.hide();
    });

    $("#shipping_selection_sameday_delivery").on("change", function (e) {
      pdpLocationSelection.removeClass("expand");
      $(".purchase-option--sameday-delivery .selection-form").removeClass(
        "selection-form--hidden"
      );
      locationSelection.hide();
    });

    /**
     * if in store pick up is selected, show location selection and lookupInventory for the selected variant
     */
    pickUpInput.on("change", function (e) {
      addToCartButton.attr("disabled", true);
      locationSelection.show();
      lookupInventory();
      pickupSelection.addClass("expand");
      sameDayDeliverySelection.removeClass("expand");
      optOutOfSubscription();

      if ($(".pickup-availability-message").hasClass("pickup--error")) {
        addToCartButton.attr("disabled", true);
      }
    });

    /**
     * if same day delivery is selected, show location selection and lookupInventory for the selected variant
     */
    sameDayDeliveryInput.on("change", function (e) {
      addToCartButton.attr("disabled", true);
      locationSelection.show();
      lookupInventory();
      sameDayDeliverySelection.addClass("expand");
      pickupSelection.removeClass("expand");
      optOutOfSubscription();

      if (
        $(".sameday-delivery-availability-message").hasClass(
          "sameday-delivery--error"
        )
      ) {
        addToCartButton.attr("disabled", true);
      }
    });

    // Image Galleries
    if ($(".swiper-pagination").length) {
      setTimeout(() => {
        window.photo_gallery = new Swiper(".gallery", {
          loop: false,
          effect: "slide",
          speed: 300,
          navigation: {
            nextEl: ".gallery .swiper-button-next",
            prevEl: ".gallery .swiper-button-prev",
          },
          pagination: {
            el: ".gallery .swiper-pagination",
            type: "bullets",
          },
        });
      }, 0);
    }

    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $("#add-item-form"),
    });

    // Product recommendations API
    function displayRecommendedProducts(products) {
      products.forEach(function (product) {
        var product_loop_template = $("#related-product__template").html();
        var compiled_html = _.template(product_loop_template, product);
        $(".section--related-products .products").append(
          compiled_html({ product: product })
        );
      });

      const observeDOM = (function () {
        const MutationObserver =
          window.MutationObserver || window.WebKitMutationObserver;

        return function (obj, callback) {
          if (!obj || obj.nodeType !== 1) return;

          if (MutationObserver) {
            const mutationObserver = new MutationObserver(callback);

            mutationObserver.observe(obj, {
              childList: true,
              subtree: true,
            });

            return mutationObserver;
          } else if (window.addEventListener) {
            obj.addEventListener("DOMNodeInserted", callback, false);
            obj.addEventListener("DOMNodeRemoved", callback, false);
          }
        };
      })();

      const onScriptAppended = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            const zyncScript = document.querySelector("#zync-script");
            if (zyncScript) {
              zyncScript.addEventListener("load", () => {
                const relatedProductIds = products.map((product) => product.id);

                if (relatedProductIds) {
                  const pageData = {
                    url: window.location.href,
                    ids: relatedProductIds,
                    resourcetype: "product",
                  };
                  bt("track", "similar_items", pageData);
                }
              });
              observer.disconnect();
              break;
            }
          }
        }
      };

      // Observe the entire document for script additions & Track similar items view, once the zync script is loaded
      observeDOM(document.documentElement, onScriptAppended);
    }

    function getRecommendedProducts(id) {
      $.getJSON(
        "/recommendations/products.json?product_id=" + id + "&limit=4",
        function (resp) {
          if (resp.products && resp.products.length) {
            const extensions = [".jpg", ".jpeg", ".png", ".webp"];
            const suffix = "_400x";

            let productsWithFormattedImage = resp.products.map((p) => {
              extensions.forEach((extension) => {
                if (p.featured_image.includes(extension)) {
                  p.featured_image = p.featured_image.replace(
                    extension,
                    `${suffix}${extension}`
                  );
                }
              });

              return p;
            });

            displayRecommendedProducts(productsWithFormattedImage);
          } else {
            $(".section--related-products").hide();
          }
        }
      );
    }

    function initRecommendedProducts() {
      if (rehash_related_products && rehash_related_products.length) {
        displayRecommendedProducts(rehash_related_products);
      } else {
        getRecommendedProducts(product.data.id);
      }
    }

    /** HTML Sanitization Function */
    function sanitizeHTML(html) {
      // Create a temporary div to parse HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      // Remove script tags and event handlers
      const scripts = tempDiv.querySelectorAll("script");
      scripts.forEach((script) => script.remove());

      // Remove dangerous attributes
      const dangerousAttributes = [
        "onclick",
        "onload",
        "onerror",
        "onmouseover",
        "onmouseout",
        "onfocus",
        "onblur",
        "onchange",
        "onsubmit",
        "onreset",
        "onselect",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "javascript:",
        "vbscript:",
        "data:",
      ];

      const allElements = tempDiv.querySelectorAll("*");
      allElements.forEach((element) => {
        // Remove dangerous attributes
        dangerousAttributes.forEach((attr) => {
          element.removeAttribute(attr);
        });

        // Clean href and src attributes
        if (element.hasAttribute("href")) {
          const href = element.getAttribute("href");
          if (
            href &&
            (href.startsWith("javascript:") ||
              href.startsWith("vbscript:") ||
              href.startsWith("data:"))
          ) {
            element.removeAttribute("href");
          }
        }

        if (element.hasAttribute("src")) {
          const src = element.getAttribute("src");
          if (
            src &&
            (src.startsWith("javascript:") ||
              src.startsWith("vbscript:") ||
              src.startsWith("data:"))
          ) {
            element.removeAttribute("src");
          }
        }
      });

      return tempDiv.innerHTML;
    }

    /** PDP Information Tabs */
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("product-info-tab")) {
        const tabId = e.target.id;
        const panelId = `${tabId.replace("-tab", "-panel")}`;
        const panelContent = document.querySelector(`#${panelId}`).innerHTML;
        const isActive = e.target.classList.contains("active");

        /** Remove 'active' from all tabs and hide all panels */
        document
          .querySelectorAll(".product-info-tab")
          .forEach((tab) => tab.classList.remove("active"));
        document
          .querySelectorAll(".product-info-panel")
          .forEach((panel) => panel.classList.remove("active"));

        /** Toggle the clicked tab and render its content inside #product-info-panels */
        if (!isActive) {
          e.target.classList.add("active");
          const productInfoPanels = document.querySelector(
            "#product-info-panels"
          );
          productInfoPanels.innerHTML = panelContent;
        }
      }
    });

    function renderPdpInformationTabs() {
      const pdpProductInformation = JSON.parse(
        document
          .querySelector("#pdp-information-tab-data")
          ?.textContent.trim() ?? "null"
      );
      const tabsContainer = document.getElementById("product-info-tabs");

      if (!pdpProductInformation?.data) return;

      pdpProductInformation.data.forEach((item, index) => {
        const tabId = `${item.name.toLowerCase().replace(/\s+/g, "-")}-tab`;
        const panelId = `${item.name.toLowerCase().replace(/\s+/g, "-")}-panel`;

        /** Create tab title inside a wrapper */
        const tab = `
          <div class="product-info-wrapper">
            <div class="product-info-tab" id="${tabId}">${item?.value?.name}</div>
            <div class="product-info-panel" id="${panelId}">
        `;

        let panelContent = "";

        // Loop through all contents and handle each type
        item.value.contents.forEach((content) => {
          if (content?.data?.type === "TABLE") {
            const tableData = content.data;
            const tableRowsData = tableData.rowsData
              .map(
                (row) =>
                  `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
              )
              .join("");

            let tableHTML = "";

            // Only render header if rowMeta has non-empty values
            if (tableData.rowMeta?.some((header) => header?.trim())) {
              const headerRow = tableData.rowMeta
                .map((header) => `<th>${header}</th>`)
                .join("");
              tableHTML = `
                 <table>
                   <thead><tr>${headerRow}</tr></thead>
                   <tbody>${tableRowsData}</tbody>
                 </table>
               `;
            } else {
              tableHTML = `
                 <table>
                   <tbody>${tableRowsData}</tbody>
                 </table>
               `;
            }

            panelContent += tableHTML;
          } else if (content?.data?.type === "PARAGRAPH") {
            panelContent += content.data.values
              .map((text) => `<p>${text}</p>`)
              .join("");
          } else if (content?.data?.type === "LIST") {
            const listItems = content.data.values
              .map((item) => `<li>${item}</li>`)
              .join("");
            panelContent += `<ul>${listItems}</ul>`;
          } else if (content?.data?.type === "HTML") {
            // Sanitize and clean HTML content
            const sanitizedHTML = sanitizeHTML(content.data.values.join(""));
            panelContent += sanitizedHTML;
          }
        });

        /** Close panel wrapper */
        const panel = `${panelContent}</div></div>`;

        /** Append tab and panel inside the wrapper */
        tabsContainer.innerHTML += tab + panel;

        /** Set first tab and panel as active by default & render selected panel content */
        if (index === 0) {
          tabsContainer.querySelector(`#${tabId}`).classList.add("active");
          tabsContainer.querySelector(`#${panelId}`).classList.add("active");
          const productInfoPanels = document.querySelector(
            "#product-info-panels"
          );
          productInfoPanels.innerHTML = panelContent;
        }
      });
    }

    // Initial render of tabs and content
    renderPdpInformationTabs();

    initRecommendedProducts();
  };

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product class
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Product = (function () {
    function Product(options) {
      var inputs, input_type;
      this.productInformation = null;
      this.$container = options.$container;
      this.data = JSON.parse(
        document.getElementById("product__json").innerHTML
      );
      this.variantInventory = JSON.parse(
        document.getElementById("variant_inventory_json").innerHTML
      );

      this.settings = {
        single_option_selector: ".single-option-select",
        original_select_id: "select#product-select",
      };

      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr("type");

        if (input_type === "radio" || input_type === "checkbox") {
          inputs.filter(":checked:first").trigger("change");
        } else {
          inputs.first().trigger("change");
        }
      } else {
        if (console) {
          console.log("Missing product json data!");
        }
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {
      _initVariants: function () {
        var options = {
          $container: this.$container,
          enable_history_state: true,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data,
        };

        this.productInformation = new REBASE.theme.Variants(options);
        this.$container.on("variantChange", this._updateAddToCart.bind(this));
        this.$container.on(
          "shippingTypeChange",
          this._updateAddToCart.bind(this),
          this._updateShippingPreference.bind(this)
        );
        this.$container.on("variantImageChange", this._updateImages.bind(this));
        this.$container.on("variantPriceChange", this._updatePrice.bind(this));
        this.$container.on("variantSKUChange", this._updateSKU.bind(this));
      },

      _updateAddToCart: function (e) {
        const low_stock_notice = $(".ea-low-stock-warning");
        const variantId = $("#product-select").val();
        const currentVariant = this.data.variants.filter(
          (product) => +product.id === +variantId
        )[0];
        const variant = e.variant || currentVariant;

        if (!variant) {
          addToCartButton.addClass("disabled").attr("disabled", "disabled");
          addToCartText.text("Not Available");
          $(".product-pricing .product-price").html(
            "<span>Not Available</span>"
          );
          $(".product-pricing .old-price").empty();
          low_stock_notice.hide();
        } else {
          // NOTE: variants can be available for online purchase, but not available for shipping
          // Some variants are available according to shopify (no tracked inventory, for instance)
          // BUT products require a 'template:ship-ea' tag to be available for 'Ship to Me'.
          // The 'Ship To Me' input will be disabled via Liquid if this tag is not present.
          // Hence, we have to check for more than just variant.available
          const disableATC = () => {
            addToCartButton.addClass("disabled").attr("disabled", "disabled");
            addToCartText.text("Sold Out");
            low_stock_notice.hide();
          };

          if (variant.available) {
            if ($("#shipping_selection_pickup:checked").length) {
              // if no location is set & pickup is checked, disable ATC button
              if (!JSON.parse(localStorage.getItem("locationSelection"))) {
                addToCartButton
                  .addClass("disabled")
                  .attr("disabled", "disabled");
              }
            } else if ($("#shipping_selection_shipped:checked").length) {
              addToCartButton.removeClass("disabled").removeAttr("disabled");
            }
            addToCartText.text("Add To Cart");
            if (
              this.variantInventory &&
              this.variantInventory[variant.id] &&
              this.variantInventory[variant.id] <= 10
            ) {
              low_stock_notice.show();
            }
          }

          /**
           * Disable ATC when changing shippingType and variant is not available
           */
          if (e.type === "shippingTypeChange") {
            const shipPref = e.target.id || shipPref;
            const shipped = "shipping_selection_shipped";

            if (!variant.available && getShipPref() === shipped) {
              disableATC();
            }
          } else {
            /**
             * Disable atc when switching variant type if variant is not available
             */
            if (!variant.available) {
              disableATC();
              disableInputs();
            } else if (!shippingInput.is(":disabled")) {
              shippingInput
                .parent()
                .closest(".purchase-option")
                .removeClass("disabled");
            }
          }
        }
      },
      _updateShippingPreference: function (e) {
        const locationData = JSON.parse(
          localStorage.getItem("locationSelection")
        );

        /**
         * Remove all active classes on update, add active class to target parent
         */
        $(".purchase-option").removeClass("active");
        $(e.target).parent().closest(".purchase-option").addClass("active");
        localStorage.setItem("shipPref", e.target.id);

        if (!locationData) {
          return false;
        }
      },
      _updateImages: function (e) {
        // Bail if there is no photo_gallery
        if (!window.photo_gallery) {
          return;
        }

        const variant = e.variant;
        const variant_slide_index = $(
          '.gallery .swiper-slide[data-main-image-id="' +
            variant.featured_image.id +
            '"]'
        ).data("swiperSlideIndex");
        if (variant_slide_index) {
          window.photo_gallery.slideTo(variant_slide_index);
        }
      },
      _updatePrice: function (e) {
        var variant = e.variant,
          main_price = $(".product-pricing .product-price"),
          old_price = $(".product-pricing .old-price"),
          compare_price = variant.compare_at_price;

        main_price.html(
          Shopify.formatMoney(variant.price, Shopify.money_format).replace(
            ".00",
            ""
          )
        );

        if (compare_price && compare_price > variant.price) {
          old_price.html(
            Shopify.formatMoney(compare_price, Shopify.money_format).replace(
              ".00",
              ""
            )
          );
        } else {
          old_price.empty();
        }
      },
      _updateSKU: function (e) {
        $("#product-sku .product-meta-item-content").text(e.variant.sku);
      },
    });

    return Product;
  })();

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product Variants class - based on Shopify debut
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Variants = (function () {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};

      /**
       * Event listeners on radio inputs to update hidden select
       */
      $(".pdp-option-input").on("change", (e) => {
        this._optionChange(e.target.value);
      });

      $('input[name="properties[_shipping]"]').on(
        "change",
        this._onShippingTypeChange.bind(this)
      );
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      /**
       * Handles the display of the purchase option based on the shipPref stored in the local storage
       */
      _purchaseOptionDisplay: async function (variant) {
        const pickUp = "shipping_selection_pickup";
        const sameDayDelivery = "shipping_selection_sameday_delivery";
        const shipped = "shipping_selection_shipped";

        /** Initially hide ordergroove */
        ogOffer.hide();
        if (getShipPref() === pickUp && !pickUpInput.prop("disabled")) {
          $(
            ".purchase-option-pickup .product-page-location-selection"
          ).addClass("expand");

          const locationData = JSON.parse(
            localStorage.getItem("locationSelection")
          );
          if (locationData) {
            $(".pickup-availability-message").addClass("badge");
            $(".sameday-delivery-availability-message").removeClass("badge");
            $(".shipping-availability-message").removeClass("badge");
          }
        } else if (
          getShipPref() === sameDayDelivery &&
          !pickUpInput.prop("disabled")
        ) {
          $(
            ".purchase-option-sameday-delivery .product-page-location-selection"
          ).addClass("expand");

          const locationData = JSON.parse(
            localStorage.getItem("deliverySelection")
          );
          if (locationData) {
            $(".pickup-availability-message").removeClass("badge");
            $(".sameday-delivery-availability-message").addClass("badge");
            $(".shipping-availability-message").removeClass("badge");
          }
        } else {
          $(".pickup-availability-message").removeClass("badge");
          $(".sameday-delivery-availability-message").removeClass("badge");
        }

        if (getShipPref() === shipped) {
          /** Display ordergroove if available */
          ogOffer.show();
          /** If product is available for purchase, check EA inventory stock */
          $(".shipping-availability-message").addClass("badge");
          await window.lookUpSFSInventory(variant);
        }
      },

      /**
       * Event handler for when shipping type changes
       */
      _onShippingTypeChange: function (e) {
        const variantId = $("#product-select").val();
        const variant = this.product.variants.filter(
          (product) => +product.id === +variantId
        )[0];

        this.$container.trigger({
          type: "shippingTypeChange",
          variant: variant[0],
          target: e.target,
        });

        this.current_variant = variant;
        this._purchaseOptionDisplay(this.current_variant);
      },

      /**
       * Event handler for when a variant input changes.
       * Get variant product by variant title provided via radio inputs
       */
      _optionChange: function (variantTitle) {
        const variant = this.product.variants.filter(
          (product) => product.title === variantTitle
        )[0];

        if (!variant) {
          this.current_variant = {};
          return;
        }

        this._updateMasterSelect(variant);
        this.$container.trigger({
          type: "variantChange",
          variant: variant,
        });

        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this._updatePromo(variant);
        this._purchaseOptionDisplay(variant);
        this.current_variant = variant;
        displayPortalLink(variant.id);
        if (this.enable_history_state) {
          this._updateHistoryState(variant);
        }
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function (variant) {
        var variant_image = variant.featured_image || {},
          current_variant_image = this.current_variant.featured_image || {};

        if (
          !variant.featured_image ||
          variant_image.src === current_variant_image.src
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantImageChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function (variant) {
        if (
          variant.price === this.current_variant.price &&
          variant.compare_at_price === this.current_variant.compare_at_price
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantPriceChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function (variant) {
        if (variant.sku === this.current_variant.sku) {
          return;
        }

        this.$container.trigger({
          type: "variantSKUChange",
          variant: variant,
        });
      },

      _updatePromo: function (variant) {
        const variantAlerts = document.querySelectorAll("[data-variant-alert]");
        variantAlerts.forEach((alert) => {
          alert.getAttribute("data-variant-alert") == variant.id
            ? alert.classList.remove("hide")
            : alert.classList.add("hide");
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function (variant) {
        $(this.original_select_id).val(variant.id);
      },
    });

    return Variants;
  })();
})(jQuery);
